import { PackageExportReadyMessage, PackageExportStartedMessage } from "@app/catalog";
import { ToastLevel } from "@app/components";
import { Notification } from "@app/shared";


@Notification({
    name: 'PackageExportStartedNotification'
})
export class PackageExportStartedNotification {
    public packageName: string;

    public getMessage(){
       return { message: new PackageExportStartedMessage(this.packageName), id: this['id'], createdDate: this['createdDate'], isDismissable: this['isDismissable'], sender: this['sender'], level: ToastLevel.Information };
    }
}


@Notification({
    name: 'PackageExportReadyNotification'
})
export class PackageExportReadyNotification {
    public packageName: string;
    public url: string;

    public getMessage(){
       return { message: new PackageExportReadyMessage(this.packageName, this.url), id: this['id'], createdDate: this['createdDate'], isDismissable: this['isDismissable'], sender: this['sender'], level: ToastLevel.Information };
    }
}